import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const DeviceTable = styled.div`
  border: 1px solid ${tokens.color.neutral_200};
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 24px;

  .device-table-title {
    ${tokens.text('subtitle2')};
    margin-bottom: 16px;
  }

  .device-table-body {
    .device-table-item {
      display: flex;
      flex-direction: row;
      align-items: center;

      .device {
        ${tokens.text('subtitle2')};
        color: ${tokens.ALIAS_TEXT_COLORS.text_light};
        width: 245px;
      }

      .time-stamp {
        flex: 1;
      }
    }
  }
`;
